<template>
  <div class="referral-landing">
    <b-spinner label="Yönlendiriliyor..." />
  </div>
</template>

<script>
export default {
  name: 'ReferralLanding',
  mounted() {
    const code = String(this.$route.params.code || '').trim().toUpperCase()
    if (/^[A-Z0-9]{6}$/.test(code)) document.cookie = `referral_code=${encodeURIComponent(code)}; Max-Age=${60 * 60 * 24 * 14}; Path=/; SameSite=Lax`
    this.$router.replace({ name: 'auth-login' })
  },
}
</script>
